import { selectChangeMessageForCoverage } from '@UI/aside/asideCoverage/asideCoverageSelectors';
import { selectChangeMessageForNamedSets } from '@UI/aside/asideNamedSet/asideNamedSetSelectors';
import type { AudienceTabComponent } from '@nodeTypeConfig/configTypes';

export const proThemeAudienceTab: Array<AudienceTabComponent> = [
  {
    component: 'namedSet',
    reactComponent: 'AsideNamedSet',
    property: 'mainstructuresOuTypeCombinations',
    label: 'Onderwijsniveaus en instellingstypes',
    subLabel: 'Voor wie is deze inhoud bestemd?',
    labelSingular: 'Onderwijsniveau en instellingstype',
    tag: 'mainstructure_outype_ext_comm',
    isInheritedProperty: true,
    asideChangeMessageSelector: selectChangeMessageForNamedSets,
  },
  {
    component: 'coverage',
    reactComponent: 'AsideCoverage',
    property: 'coverage',
    label: "Regio's",
    labelSingular: 'Regio',
    isInheritedProperty: true,
    asideChangeMessageSelector: selectChangeMessageForCoverage,
  },
];
